module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-06.7380e512.png";